import * as React from 'react';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';

export const SearchBoxUnderlinedExample = () => <SearchBox placeholder="Search" underlined={true} />;
